import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

const useSanitizedHtml = (rawHtml, allowIframe = false) => {
  const [sanitizedHtml, setSanitizedHtml] = useState('');

  useEffect(() => {
    let sanitizeOptions ={USE_PROFILES: { html: true }};

    if (allowIframe) {
      sanitizeOptions = {
        USE_PROFILES: { html: true },
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen', 'style'],
      };
    }

    const sanitized = DOMPurify.sanitize(rawHtml, sanitizeOptions);
    setSanitizedHtml(sanitized);

  }, [rawHtml, allowIframe]);

  return sanitizedHtml;
};

export default useSanitizedHtml;
